import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-profile-validate-password',
  templateUrl: './profile-validate-password.component.html',
  styleUrls: ['./profile-validate-password.component.scss'],
  standalone: false
})
export class ProfileValidatePasswordComponent implements OnInit {
  passwordForm: FormGroup;
  visible = false;

  @Input() validatePasswordLoading: boolean;
  @Output() validatePassword: EventEmitter<string> = new EventEmitter<string>();
  @Output() cancelValidate: EventEmitter<void> = new EventEmitter<void>();

  get passwordControl(): AbstractControl | null {
    return this.passwordForm.get('password');
  }

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.passwordForm = this.fb.group({
      password: ['', Validators.required]
    });
  }

  onSubmit() {
    if (this.passwordForm.invalid) {
      return;
    }
    this.validatePassword.emit(this.passwordControl.value as string);
  }

  onCancel() {
    this.cancelValidate.emit();
  }
}
